import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class FontService {
  private readonly document = inject(DOCUMENT);

  private readonly GOOGLE_FONTS_MAP: Record<string, string> = {
    'Roboto':     'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap',
    'Montserrat': 'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;700&display=swap',
  };

  injectGoogleFont(fontName: string): void {
    const url = this.GOOGLE_FONTS_MAP[fontName];
    if (!url || this.document.querySelector(`link[data-font="${fontName}"]`)) {
      return;
    }

    const link = this.document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.setAttribute('data-font', fontName);
    this.document.head.appendChild(link);
  }
}
